import {
    isScreenAtLeast,
    gsapTimelinePromise,
    throttle,
} from '../../../common/utils';

import els from './elements';

let context = null;
let advancing = false;
let timeline = null;

let autoplay = null;
let resumeTimeout = null;

const AUTOPLAY_DELAY = 5000;
const RESUME_DELAY = 3000;

const advanceTo = async (nextIndex) => {

    if (advancing) return;

    advancing = true;

    const $blocks = els.$blocks();
    const $blockButtons = els.$blockButtons();

    const $activeBlock = els.$activeBlock();
    const index = $activeBlock.index();
    const $activeBlockButton = $blockButtons.eq(index);

    const direction = nextIndex - index > 0 ? 1 : -1;

    const $nextBlock = $blocks.eq(nextIndex);
    const $nextBlockButton = $blockButtons.eq(nextIndex);

    if (nextIndex === index) {
        advancing = false;
        return;
    }

    timeline = gsap.timeline();

    timeline.to(
        $activeBlock,
        { autoAlpha: 0, y: -direction * 100 },
    );

    timeline.fromTo(
        $nextBlock,
        { autoAlpha: 0, y: direction * 100 },
        { autoAlpha: 1, y: 0 },
        '<'
    );

    $activeBlockButton
        .removeClass('bg-yellow')
        .addClass('bg-blue-dark')

    $nextBlockButton
        .removeClass('bg-blue-dark')
        .addClass('bg-yellow')


    await gsapTimelinePromise(timeline);

    $activeBlock.removeAttr('data-active');
    $nextBlock.attr('data-active', '');

    advancing = false;
};

const startAutoplay = () => {

    autoplay = (
        setInterval(
            () => {
                const index = els.$activeBlock().index();
                const nextIndex = (
                    index + 1 > els.$blocks().length - 1
                        ? 0
                        : index + 1
                );
                advanceTo(nextIndex);
            },
            AUTOPLAY_DELAY
        )
    );
};

const pauseAutoplay = () => {

    clearInterval(autoplay);
    clearTimeout(resumeTimeout);

    resumeTimeout = (
        setTimeout(
            () => {
                startAutoplay();
            },
            RESUME_DELAY
        )
    );
};

const prepareForDesktop = () => {

    const $blocksWrap = els.$blocksWrap();
    const $blocks = els.$blocks();
    const $firstBlock = $blocks.first();
    const $blockButtons = els.$blockButtons();
    const $firstBlockButton = $blockButtons.first();
    const $otherBlockButtons = $blockButtons.not($firstBlockButton);
    const $content = els.$content();

    context = gsap.context(() => {

        const paddingTop = (
            ($content.height() * 0.5)
            - ($firstBlock.height() * 0.75)
        );

        $firstBlock.attr('data-active', '');

        gsap.set($blocksWrap, { paddingTop });

        $firstBlockButton.removeClass('bg-blue-dark');
        $firstBlockButton.addClass('bg-yellow');

        $otherBlockButtons.removeClass('bg-yellow');
        $otherBlockButtons.addClass('bg-blue-dark');

        gsap.set($blocksWrap, { visibility: 'visible' });

        gsap.set($blocks, { autoAlpha: 0 });

        gsap.set($firstBlock, { autoAlpha: 1 });
    });

    startAutoplay();

    $blockButtons.on('click', (event) => {
        pauseAutoplay();
        advanceTo($(event.target).index());
    });
};

const prepareForMobile = () => {

    context = gsap.context(async () => {

        const $blocksWrap = els.$blocksWrap();
        const $blocks = els.$blocks();

        $blocks.each((index, element) => {

            const isEven = (index + 1) % 2 === 0;
            const direction = isEven ? 1 : -1;

            gsap.fromTo(
                element,
                {
                    xPercent: direction * 50,
                    autoAlpha: 0,
                },
                {
                    xPercent: 0,
                    autoAlpha: 1,
                    ease: 'power4.inOut',
                    duration: 0.75,
                    scrollTrigger: {
                        trigger: element,
                        start: 'top 80%',
                    },
                }
            )
        });

        gsap.set($blocksWrap, { autoAlpha: 1 });
    });
};

const prepare = () => {

    if (!isScreenAtLeast('lg')) {
        prepareForMobile();
    } else {
        prepareForDesktop();
    }

};

const cleanUp = () => {

    const $blocksWrap = els.$blocksWrap();
    const $blocks = els.$blocks();

    clearInterval(autoplay);
    clearTimeout(resumeTimeout);

    context?.revert();

    gsap.set($blocksWrap, { clearProps: 'all' });
    gsap.set($blocks, { clearProps: 'all' });

    els.$blockButtons().off('click');
};

const initialize = () => {

    prepare();

    $(window).on(
        'resize:horizontally',
        throttle(
            () => {
                cleanUp();
                prepare();
            },
            50
        )
    )
};

export default {
    initialize,
};

